import {createStore} from '@ngneat/elf';
import {withEntities} from '@ngneat/elf-entities';
import {withRequestsStatus} from '@ngneat/elf-requests';
import {withPagination} from '@ngneat/elf-pagination';
import {IssueKind} from '@store/settings/issueKinds/issueKinds.model';

export const issueKindsStore = createStore(
    {name: 'issue-kinds'},
    withEntities<IssueKind>(),
    withPagination(),
    withRequestsStatus(),
);